export const DEFAULT_IPMS_IDS = [80]
export const IPMS_IDS = [69, 70, 71, 72, 73, 74]
export const IPMS4_IDS = [73, 74]